/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-13 21:11:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-06-02 09:54:41
 */
import createModel, { Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  ParamsteamsTeamIdFollowUsingPost,
  ParamsgroupsGroupIdJoinUsingPost,
  GroupVO,
  TeamVO
} from '@src/services';
import { message } from 'antd';
import { ACTIVE_NAV_GROUP, ACTIVE_GROUP_ALL, ACTIVE_GROUP_JOINED } from '@src/utils/constant/home';
import { PAGE_SIZE } from '@src/utils/constant/common';

export interface PageInfo {
  pageNum: number;
  pageSize: number;
  total: number;
}

export interface State {
  // @IMP: 保留activeModel层级结构
  activeModel: {
    /**  全部圈子 */
    groupList: GroupVO[];
    /** 全部圈子页面信息  */
    groupPageInfo: PageInfo;
    /** 加载loading */
    loading: boolean;
    /** 热门团队 */
    teamList: TeamVO[];
    /** 团队页面信息 */
    teamPageInfo: PageInfo;
  };
}

export const activeModelState: State = {
  activeModel: {
    groupList: [],
    teamList: [],
    teamPageInfo: { pageNum: 1, pageSize: PAGE_SIZE, total: 0 },
    groupPageInfo: { pageNum: 1, pageSize: PAGE_SIZE, total: 0 },
    loading: true
  }
};

const model = createModel({
  state: activeModelState,
  namespace: 'activeModel',
  reducers: {
    /**
     * @description 设置热门团队信息
     */
    setTeamList: (state, action: Tction<{ teamList: TeamVO[] }>): typeof state => {
      return {
        ...state,
        activeModel: {
          ...state.activeModel,
          teamList: action.payload.teamList
        }
      };
    },
    /** 团队页面信息 */
    setTeamPageInfo: (state, action: Tction<{ teamPageInfo: PageInfo }>): typeof state => {
      return {
        ...state,
        activeModel: {
          ...state.activeModel,
          teamPageInfo: action.payload.teamPageInfo
        }
      };
    },
    /**
     * @description 设置热门圈子信息
     */
    setGroupList: (state, action: Tction<{ groupList: GroupVO[] }>): typeof state => {
      return {
        ...state,
        activeModel: {
          ...state.activeModel,
          groupList: action.payload.groupList
        }
      };
    },
    /** 圈子页面信息 */
    setGroupPageInfo: (state, action: Tction<{ groupPageInfo: PageInfo }>): typeof state => {
      return {
        ...state,
        activeModel: {
          ...state.activeModel,
          groupPageInfo: action.payload.groupPageInfo
        }
      };
    },
    /** 更新loading状态 */
    updateLoading: (state, action: Tction<{ loading: boolean }>): typeof state => {
      return {
        ...state,
        activeModel: {
          ...state.activeModel,
          loading: action.payload.loading
        }
      };
    },
    /** 更新热门团队的状态 */
    updateTeamList: (state, action: Tction<{ teamId: number; follow: boolean }>): typeof state => {
      const { teamId, follow } = action.payload;
      return {
        ...state,
        activeModel: {
          ...state.activeModel,
          teamList: state.activeModel.teamList.map((item: TeamVO) => {
            if (item.id === teamId) {
              return {
                ...item,
                relation: follow ? 2 : 0,
                followed: follow,
                followerNumber: follow
                  ? (item.followerNumber || 0) + 1
                  : (item.followerNumber || 0) - 1
              };
            }
            return item;
          })
        }
      };
    },
    /** 更新圈子的状态 */
    updateGroupList: (state, action: Tction<{ groupId: number; join: boolean }>): typeof state => {
      const { groupId, join } = action.payload;
      return {
        ...state,
        activeModel: {
          ...state.activeModel,
          groupList: state.activeModel.groupList.map((item: GroupVO) => {
            if (item.id === groupId) {
              return {
                ...item,
                relation: join ? 1 : 0,
                joined: join,
                member: join ? (item.member || 0) + 1 : (item.member || 0) - 1
              };
            }
            return item;
          })
        }
      };
    }
  },
  effects: {
    /**
     * @description 获取热门团队列表
     */
    *getTeamList(
      { tPut, tCall },
      action: Tction<{
        pageNum: number;
        pageSize: number;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.updateLoading, { loading: true });
      const res: Utils.GetROA<typeof APIS.TeamApi.teamsAllUsingGet> = yield tCall(
        APIS.TeamApi.teamsAllUsingGet,
        {
          pageNum: action.payload.pageNum,
          pageSize: action.payload.pageSize
        }
      );
      yield tPut(model.actions.updateLoading, { loading: false });
      if (res.code === 0) {
        yield tPut(model.actions.setTeamList, {
          teamList: res.result?.list || []
        });
        yield tPut(model.actions.setTeamPageInfo, {
          teamPageInfo: {
            pageNum: res.result?.pageNum || 1,
            pageSize: res.result?.pageSize || PAGE_SIZE,
            total: res.result?.total || 0
          }
        });
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description  获取全部圈子列表
     */
    *getGroupList(
      { tPut, tCall },
      action: Tction<{
        pageNum: number;
        pageSize: number;
        type: string;
      }>
    ): Iterator<{}, any, any> {
      const { pageNum, pageSize, type } = action.payload;
      yield tPut(model.actions.updateLoading, { loading: true });
      let res;
      if (type === ACTIVE_GROUP_ALL) {
        res = yield tCall(APIS.GroupApi.groupsAllUsingGet, {
          pageNum: pageNum,
          pageSize: pageSize,
          isAdmin: false
        });
      }
      if (type === ACTIVE_GROUP_JOINED) {
        res = yield tCall(APIS.GroupApi.groupsJoinsUsingGet, {
          pageNum: pageNum,
          pageSize: pageSize
        });
      }
      yield tPut(model.actions.updateLoading, { loading: false });
      if (res.code === 0) {
        yield tPut(model.actions.setGroupList, {
          groupList: res.result?.list || []
        });
        yield tPut(model.actions.setGroupPageInfo, {
          groupPageInfo: {
            pageNum: res.result?.pageNum || 1,
            pageSize: res.result?.pageSize || PAGE_SIZE,
            total: res.result?.total || 0
          }
        });
      } else {
        message.error(res.message);
      }
    },

    /**
     * 分页
     * @param param0
     * @param action
     */
    *changePage(
      { tPut },
      action: Tction<{ type: string; pageNum: number; tabKey: string }>
    ): Iterator<{}> {
      const { type, pageNum, tabKey } = action.payload;
      if (type === ACTIVE_NAV_GROUP) {
        yield tPut(model.actions.getGroupList, {
          pageNum: pageNum,
          pageSize: PAGE_SIZE,
          type: tabKey
        });
      } else {
        yield tPut(model.actions.getTeamList, { pageNum: pageNum, pageSize: PAGE_SIZE });
      }
    },
    /**
     * @description 根据id加入或者退出圈子
     */
    *toggleJoinGroup(
      { tPut, tCall },
      action: Tction<{
        params: ParamsgroupsGroupIdJoinUsingPost;
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { callback, params } = action.payload;
      const res: Utils.GetROA<typeof APIS.GroupApi.groupsGroupIdJoinUsingPost> = yield tCall(
        APIS.GroupApi.groupsGroupIdJoinUsingPost,
        params
      );
      if (res.code === 0) {
        const { groupId, join } = params;
        yield tPut(model.actions.updateGroupList, { groupId, join });
        message.success(join ? '已成功加入' : '已退出圈子');

        callback && callback();
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 根据id关注取关团队
     */
    *toggleFollowTeam(
      { tPut, tCall },
      action: Tction<{
        params: ParamsteamsTeamIdFollowUsingPost;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.TeamApi.teamsTeamIdFollowUsingPost> = yield tCall(
        APIS.TeamApi.teamsTeamIdFollowUsingPost,
        action.payload.params
      );
      if (res.code === 0) {
        const { teamId, follow } = action.payload.params;
        yield tPut(model.actions.updateTeamList, { teamId, follow });
        message.success(follow ? '关注成功' : '已取消关注');
      } else {
        message.error(res.message);
      }
    }
  }
});

/**
 * @description 全局Model activeModel 挂载到 redux 上
 */
export default model;
